module.exports = __webpack_public_path__ + "img/phone-transparent-4-layer.d150663c.png";